import mux from "mux-embed";

import { getConsent } from "../../helpers/analyticsHelpers";
import {
  isAreenaEmbed,
  isYleAppEmbed,
  isYleEmbed
} from "../../helpers/commonUtils";
import { isAudio } from "../../helpers/previewHelpers";
import { AudioTrack } from "../../types/common";
import { ContentType, Subtitles } from "../../types/player-api";

export type AudioTrackChange = Partial<AudioTrack> & { time: number };
export type SubtitlesChange = Partial<Subtitles> & { time: number };
export const getPlayerVersion = () =>
  "__PLAYER_STATIC_BUILD_VERSION__".replace(
    /__.*__/,
    process.env.NODE_ENV === "development" ? "development" : "version missing"
  );

export const resolvePlayername = (
  type: "audio" | "hlsVideo" | "nativeVideo"
) => {
  switch (type) {
    case "audio":
      return "YleAudioPlayer";
    case "nativeVideo":
      return "YlePlayer Native";
    default:
      return "YlePlayer HlsJs";
  }
};

export const resolveMediaType = (
  contentType?: ContentType
): "audio" | "video" | "unknown" => {
  if (!contentType) {
    return "unknown";
  }

  return isAudio(contentType) ? "audio" : "video";
};

export const resolveExperimentName = ():
  | "areena web"
  | "yle.fi web"
  | "yle.fi app"
  | undefined => {
  if (isAreenaEmbed()) {
    return "areena web";
  }
  if (isYleAppEmbed()) {
    return "yle.fi app";
  }
  if (isYleEmbed()) {
    return "yle.fi web";
  }
};

const isCookieAllowed = () => {
  const USER_CONSENT_DEVELOPMENT = "development";
  const consent = getConsent();
  const values = (consent.userconsent || consent.yleconsent || "").split("|");
  return !!values.find(value => value === USER_CONSENT_DEVELOPMENT);
};

export const isMuxEnabled = (analytics: boolean | undefined) =>
  analytics && __MUX_ENABLED && typeof mux !== "undefined" && isCookieAllowed();

export const getSelectedAudioTrack = (
  availableAudioTracks: AudioTrack[],
  selectedAudioTrackId?: number
) => {
  return selectedAudioTrackId !== undefined
    ? availableAudioTracks?.find(at => at.id === selectedAudioTrackId)
    : undefined;
};

export const getAudioTrackData = (
  audioTrackChanges: AudioTrackChange[],
  selectedAudioTrack?: AudioTrack
) => {
  return {
    custom_1: JSON.stringify(audioTrackChanges),
    custom_3: selectedAudioTrack?.language ?? "",
    custom_4: selectedAudioTrack?.type ?? ""
  };
};

export const getSubtitlesData = (
  subtitlesChanges: SubtitlesChange[],
  selectedSubtitles?: Subtitles
) => {
  return {
    custom_2: JSON.stringify(subtitlesChanges),
    custom_5: selectedSubtitles?.language ?? "",
    custom_6: selectedSubtitles?.label ?? ""
  };
};
